import { HelpParameters, Help, HelpPanelColor } from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_2Screen } from "../SlotGameType1_2Screen";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../WinLines/SquareWinLineFactory";
import {  AudioManager} from "../../AudioManager";
// namespace SlotGames {
    export class FireFruits_2Screen extends SlotGameType1_2Screen {

        
        protected override helpFactory: IHelpFactory = new FireFruitsHelpFactory();
        //protected panelFactory: IPanelFactory = new FireFruitsPanelFactory();

        //LED COLOR
		protected override ColorLed:string="250,0,0\n";
        
        constructor(multigameParams: MultigameParams, initData: SlotGameInitData) {
            super(multigameParams, initData, "FireFruits");
            this.spinnableReelsParams.topBorderWidth = 0;
            this.spinnableReelsParams.bottomBorderWidth = 0;
        }

        // public PrepareFont(resourceManager: ResourceManager)
        // {
        // 	resourceManager.Add(new FontResource(this.basepath + "resources/huggable.ttf", "."+ this.resid.ScopedResourceName("font")));
        // 	resourceManager.Add(new FontResource(this.basepath + "resources/huggable.ttf", "."+ this.resid.ScopedResourceName(["lines", "font"])));
        // }
        //SEND COLOR 
        protected override color: RewardColor =
            {
                color: "white",
                coloroutherStroke: "black",
                colorinnerStroke: "red",
            }

    }

    //Help Colorized
    class FireFruitsHelpFactory implements IHelpFactory {
        public CreateNewHelp(params: HelpParameters): Help {
            return new FireFruitsHelp(params);
        }
    }

    class FireFruitsHelp extends Help {
        protected override BackgroundPanel(): HelpPanelColor {
            let color: HelpPanelColor = {
                backgroundPanelColor: "linear-gradient(rgb(38, 1, 1),rgb(89, 3, 3), rgb(140, 4, 4),rgb(89, 3, 3),rgb(38, 1, 1)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
            };

            return color;
        }
    }

    //Panel Colorized
    class FireFruitsPanelFactory implements IPanelFactory {
        public CreateNewPanel(params: PanelParams): Panel {
            return new FireFruitsPanel(params);
        }
    }

    class FireFruitsPanel extends Panel {
        protected override ButtonBackground(): ButtonColors {
            let color: ButtonColors = {
                backgroundButtonColor: "linear-gradient(rgb(38, 15, 15),rgb(89, 14, 14), rgb(140, 15, 15),rgb(89, 14, 14),rgb(38, 15, 15)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
                linearColor: "linear-gradient(to left , transparent, rgb(242, 115, 41),transparent ) 0 10 100%",
            };
            return color;

        }

    }

// }
